var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"global-loading-overlay"},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"global-loading-sheet"},[_c('div',{staticClass:"loader"}),_c('div',{staticClass:"mt-7"},[_vm._v("Loading")])])
}]

export { render, staticRenderFns }